<template>
    <DockSplitNode v-if="node?.type === 'split'" :node="node" />
    <DockCenterRegion v-else-if="node?.type === 'centerSlot'" :node="node.child" />
    <DockTabGroup
        v-else-if="node?.type === 'tabs'"
        :node="node"
        @drag-start="forwardDrag"
        @toggle-pin="forwardTogglePin"
        @focus-change="forwardFocus"
    />
    <DockPanelLeaf
        v-else-if="node?.type === 'panel'"
        :panel-id="node.panelId"
        :node-id="node.id"
        :meta="panelMeta"
        :panel-kind="panelKind"
        :collapsed="collapsed"
        :is-pinned="isPinned"
        @hide="onHide"
        @toggle-pin="forwardTogglePin"
        @drag-start="forwardDrag"
        @expand="onExpand"
        @focus-change="forwardFocus"
    />
</template>

<script>
import DockSplitNode from './DockSplitNode.vue';
import DockTabGroup from './DockTabGroup.vue';
import DockPanelLeaf from './DockPanelLeaf.vue';
import DockCenterRegion from './DockCenterRegion.vue';
import { PANEL_KIND_TOOL } from './constants.js';

export default {
    name: 'DockLayoutRenderer',
    components: { DockSplitNode, DockTabGroup, DockPanelLeaf, DockCenterRegion },

    props: {
        node: { type: Object, default: null },
    },

    inject: {
        multipanelDockLayout: { default: null },
    },

    computed: {
        panelMeta() {
            if (this.node?.type !== 'panel') return {};
            return (
                this.multipanelDockLayout?.getPanelMeta?.(this.node.panelId) || {}
            );
        },
        panelKind() {
            if (this.node?.type !== 'panel') return PANEL_KIND_TOOL;
            return (
                this.multipanelDockLayout?.getPanelKind?.(this.node.panelId) ||
                PANEL_KIND_TOOL
            );
        },
        collapsed() {
            if (this.node?.type !== 'panel') return false;
            return (
                this.multipanelDockLayout?.isPanelCollapsed?.(
                    this.node.panelId,
                ) ?? false
            );
        },
        isPinned() {
            if (this.node?.type !== 'panel') return true;
            return (
                this.multipanelDockLayout?.isPanelPinned?.(this.node.panelId) ??
                true
            );
        },
    },

    methods: {
        onHide(panelId) {
            this.multipanelDockLayout?.hidePanel?.(panelId);
        },
        onExpand(panelId) {
            this.multipanelDockLayout?.expandPanel?.(panelId);
        },
        forwardDrag(payload) {
            this.multipanelDockLayout?.startDockDrag?.(payload);
        },
        forwardTogglePin(panelId) {
            this.multipanelDockLayout?.togglePanelPinned?.(panelId);
        },
        forwardFocus(payload) {
            this.multipanelDockLayout?.onPanelFocusChange?.(payload);
        },
    },
};
</script>
